import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  BuildingApplicationFilterDto,
  BuildingApplicationItemDto,
  BuildingApplicationService,
  TenantMergeDto
} from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import { currentTenant, currentTenantId } from '@/utils/admin-utils';
import TenantTypeEnum = TenantMergeDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-application-overview',
  templateUrl: './building-application-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingApplicationOverviewComponent {

  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly buildingApplicationService = inject(BuildingApplicationService);
  private readonly currentUserService = inject(CurrentUserService);
  protected readonly TenantTypeEnum = TenantTypeEnum;
  readonly tenant = currentTenant();
  readonly tenantId = currentTenantId();

  canCreateBuildingApplications = computed(() => this.currentUserService.hasPrivilege('viewBuildingApplications'));
  form: FormGroup;

  readonly loadBuildingApplications = (filter: BuildingApplicationFilterDto) => {
    const tenantId = this.tenantId();
    const mergedFilter: BuildingApplicationFilterDto = {
      ...filter,
      applicationCreatorTenantId: tenantId
    };
    return this.buildingApplicationService.findAll({ ...mergedFilter });
  };

  readonly getCount = (filter: BuildingApplicationFilterDto) =>{
    const tenantId = this.tenantId();
    const mergedFilter: BuildingApplicationFilterDto = {
      ...filter,
      applicationCreatorTenantId: tenantId
    };
    return this.buildingApplicationService.getCount({ ...mergedFilter });
  };

  constructor() {
    this.form = this.formBuilder.group({
      textFilter: this.formBuilder.control(''),
      ownerTenantId: this.formBuilder.control<string | null>(null),
      status: this.formBuilder.control<string | null>(null),
    });
  }

  navigateToBuildingApplication(event: BuildingApplicationItemDto): void {
    this.router.navigate(['buildingApplication', event.id]);
  }

  add(): void {
    this.router.navigate(['buildingApplication', 'new']);
  }

}
